export enum STATES_DECLARATIONS {
  ATTESA_STESURA = ' ',
  BOZZA = 'B',
  COMPLETA_STESURA = 'A',
  COMPLETA_REGISTRAZIONE = 'R',
  RIFIUTO_STESURA = 'N',
}
